// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--mmL1T";
export var open = "menu-module--open--ntr0i";